import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Chip, ChipGroup } from '@walmart-web/livingdesign-components'

import texts from '../../../common/texts.json'
import CarouselVariant from './CarouselVariant'
import './ProductVariant.css'

const ProductVariant = (props) => {
  const { variants, product, history, updateProduct, isMandatoryVariantSelected, setIsMandatoryVariantSelected } = props
  const [selectedProductColorIndex, setSelectedProductColorIndex] = useState(0)
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 })
  const [selectedSize, setSelectedSize] = useState(undefined)
  const getColorIndex = ({ color }) => variants.findIndex((variant) => variant.color === color)
  const colorVariant = variants[selectedProductColorIndex]

  const primaryAttribute = 'color'
  const { PRODUCT_DETAIL } = texts

  useEffect(() => {
    window.scrollTo({ left: scrollPosition.x, top: scrollPosition.y })
  }, [product.sku])

  useEffect(() => {
    window.scrollTo({ left: scrollPosition.x, top: 0, behavior: 'smooth' })
  }, [product?.attributes?.color])

  useEffect(() => {
    const colorIndex = getColorIndex({ color: product.attributes.skuColor })
    setSelectedProductColorIndex(colorIndex)

    if (isMandatoryVariantSelected) {
      const productVariant = getProductByColorAndSize({
        color: variants[colorIndex],
        size: product.attributes.skuSize,
      })
      setSelectedSize(productVariant?.attributes?.skuSize)
    }
  }, [isMandatoryVariantSelected, product.sku])

  const getProductByColorAndSize = ({ color, size }) => {
    const { available, sizes } = color
    const [productBySize] = available
      ? sizes.filter((variantSize) => variantSize.attributes.skuSize === size && variantSize.available)
      : []

    return productBySize
  }

  const handleHistoryReplace = ({ variantSelected }) => {
    updateProduct(variantSelected, false)
    const { sku, slug } = variantSelected
    const url = `/product/sku/${sku}/${slug}`
    if (sku !== product.sku) {
      setScrollPosition({ x: window.scrollX, y: window.scrollY })
      history.replace(url)
    }
  }

  const handleColorClick = ({ variantSelected, color }) => {
    let variantToDisplay = variantSelected
    setIsMandatoryVariantSelected(false)

    const productVariant = getProductByColorAndSize({ color, size: selectedSize })
    if (productVariant?.sku) {
      variantToDisplay = productVariant
      setIsMandatoryVariantSelected(true)
    }

    const parentVariant = { ...product, ...color, ...variantToDisplay, variants }
    handleHistoryReplace({ variantSelected: parentVariant })
  }

  const handleSizeClick = ({ variantSelected, colorIndex }) => {
    setSelectedSize(variantSelected.attributes.skuSize)
    setIsMandatoryVariantSelected(true)
    const parentVariant = { ...product, ...variants[colorIndex], ...variantSelected, variants }
    handleHistoryReplace({ variantSelected: parentVariant })
  }

  return (
    <>
      <div className="product-variant__container">
        <p> {PRODUCT_DETAIL.VARIANT.COLOR}:</p>
        <span data-testid="product-variant-selected-color">{product.attributes.skuColor}</span>
      </div>

      <CarouselVariant
        variants={variants}
        product={product}
        primaryAttribute={primaryAttribute}
        handleVariantClick={handleColorClick}
      />

      <p> {PRODUCT_DETAIL.VARIANT.SIZE}: </p>
      <ChipGroup UNSAFE_className="product-variant__chip-group-container">
        {colorVariant.sizes.map((colorSize) => (
          <Chip
            key={`size-${colorSize.sku}`}
            selected={isMandatoryVariantSelected && product.sku === colorSize.sku}
            onClick={() => handleSizeClick({ variantSelected: colorSize, colorIndex: selectedProductColorIndex })}
            disabled={!colorSize.available || !colorVariant.available}
          >
            {colorSize.attributes.skuSize}
          </Chip>
        ))}
      </ChipGroup>
    </>
  )
}

ProductVariant.propTypes = {
  variants: PropTypes.array.isRequired,
  product: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  updateProduct: PropTypes.func.isRequired,
  isMandatoryVariantSelected: PropTypes.bool.isRequired,
  setIsMandatoryVariantSelected: PropTypes.func.isRequired,
}

export default withRouter(ProductVariant)
